package kz.dentalcrm.app.screens.employees.add.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.employees.Position
import kz.dentalcrm.app.data.network.response_model.services.Service

sealed interface AddEmployeeViewEvent : ViewEvent {
    
    data object LoadInitialData : AddEmployeeViewEvent
    
    data class UpdateName(val value: String) : AddEmployeeViewEvent
    
    data class UpdateSurname(val value: String) : AddEmployeeViewEvent
    
    data class UpdatePatronymic(val value: String) : AddEmployeeViewEvent
    
    data class UpdatePhone(val value: String) : AddEmployeeViewEvent
    
    data class UpdateGender(val value: String) : AddEmployeeViewEvent
    
    data class UpdateBirthDate(val value: String) : AddEmployeeViewEvent
    
    data class UpdateColor(val value: String) : AddEmployeeViewEvent
    
    data class UpdatePositions(val positions: List<Position>) : AddEmployeeViewEvent
    
    data class UpdateServices(val services: List<Service>) : AddEmployeeViewEvent
    
    data class UpdateCreateAccount(val value: Boolean) : AddEmployeeViewEvent
    
    data class UpdateEmail(val value: String) : AddEmployeeViewEvent
    
    data class UpdatePassword(val value: String) : AddEmployeeViewEvent
    
    data class TogglePermission(val permission: kz.dentalcrm.app.data.network.response_model.permissions.Permission) : AddEmployeeViewEvent
    
    data object SaveEmployee : AddEmployeeViewEvent
    
    data object ResetState : AddEmployeeViewEvent
}
